/**
 * Anger (02 §4.1): light red and 1.5x as fast. All at HURRY UP, all calm when a player dies with two
 * or more monsters left, and the last one left always angry. The C64 sets and clears the flag with
 * one loop (D_16E4) over the monsters that are neither trapped nor dead (hardware states 1..$0A).
 */

import type { Monster, World } from '../types';

/**
 * A monster in the C64's states 1..$0A: not in a bubble, not killed, not frozen by the power heart
 * ($16/$17) - the states the contact test and the anger loop take.
 */
export const live = (m: Monster): boolean => m.state !== 'trapped' && m.state !== 'dead' && !m.frozen;

/** Monsters not yet killed ($4A): the trapped still count. */
const remaining = (world: World): Monster[] => world.monsters.filter((m) => m.state !== 'dead');

function setAnger(world: World, angry: boolean): void {
  for (const m of world.monsters) if (live(m)) m.angry = angry;
}

/** HURRY UP (D_3AB8 -> D_16E4 with $FF). A trapped monster is left alone: it escapes angry anyway. */
export function angerAllMonsters(world: World): void {
  setAnger(world, true);
}

/**
 * A player's death (at its respawn, $0514): with two or more monsters left, all calm down
 * (D_16E4 with the operand at $16EF bumped to 0). The count test is the caller's on the C64.
 */
export function calmAllMonsters(world: World): void {
  if (remaining(world).length >= 2) setAnger(world, false);
}

/** Every pass ($16E0): when one monster is left and it is out of its bubble, it is angry. */
export function angerLastMonster(world: World): void {
  const left = remaining(world);
  const last = left[0];
  if (left.length === 1 && last && live(last)) last.angry = true;
}
